// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 279 ? "component---src-pages-index-jsx" : chunkId) + "-" + {"279":"bff28a36f0b8da0253a5","454":"d6d7596a3052c0d6115c"}[chunkId] + ".js";
};